var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.status =='active')?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-check")]):_vm._e(),(_vm.status !='active')?_c('v-icon',[_vm._v("mdi-minus-circle")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }